import React from 'react';
import { Link } from 'gatsby';

import { classNames } from '../utils';

const LinkBox = ({
  href,
  variant = 'base',
  external = false,
  state = {},
  children,
}) => {
  const linkStyles = classNames(
    variant === 'medium'
      ? `px-2 py-1`
      : variant === 'small'
      ? `px-2`
      : `px-3 py-2`,
    'border border-gray-500 hover:border-gray-300 rounded-md text-lg font-medium inline-block shadow-2xl'
  );

  return (
    <>
      {external ? (
        <a
          href={href}
          className={linkStyles}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-gradient select-none">{children}</span>
        </a>
      ) : (
        <Link
          to={href}
          className={linkStyles}
          activeClassName="px-3 py-1"
          state={state}
        >
          <span className="text-gradient select-none">{children}</span>
        </Link>
      )}
    </>
  );
};

export default LinkBox;
